import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Toggle/ToggleAnatomy.mdx";
import Usage from "../../Docs/Components/Toggle/ToggleUsage.mdx";

import Examples from "../../Docs/Components/Toggle/ToggleExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Toggle"
            description="Toggle lets users choose between two states or options."
            apiSources={["azure-devops-ui/Components/Toggle/Toggle.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/dMVwHGDPtjpyUUDzsJ0x1tDY/Input-controls-draft?node-id=692%3A0"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;